export const contentData = {
    "words":
        {
            "一" : { "name": "一", "pinyin": "yī", "pos": "number", "meaning": "un" },
            "二": { "name": "二", "pinyin": "Èr", "pos": "number", "meaning": "deux" },
            "三": { "name": "三", "pinyin": "sān", "pos": "number", "meaning": "trois" },
            "四": { "name": "四", "pinyin": "sì", "pos": "number", "meaning": "quatre" },
            "五": { "name": "五", "pinyin": "wǔ", "pos": "number", "meaning": "cinq" },
            "六": { "name": "六", "pinyin": "liù", "pos": "number", "meaning": "six" },
            "七": { "name": "七", "pinyin": "qī", "pos": "number", "meaning": "sept" },
            "八": { "name": "八", "pinyin": "bā", "pos": "number", "meaning": "huit" },
            "九": { "name": "九", "pinyin": "jiǔ", "pos": "number", "meaning": "neuf" },
            "十": { "name": "十", "pinyin": "shí", "pos": "number", "meaning": "dix" },
            "百": { "name": "百", "pinyin": "bǎi", "pos": "number", "meaning": "cent" },
            "千": { "name": "千", "pinyin": "qiān", "pos": "number", "meaning": "mille" },
            "万": { "name": "万", "pinyin": "wàn", "pos": "number", "meaning": "dix mille" },
            "我": { "name": "我", "pinyin": "wǒ", "pos": "pronoun", "meaning": "je" },
            "你": { "name": "你", "pinyin": "nǐ", "pos": "pronoun", "meaning": "tu" },
            "您": { "name": "您", "pinyin": "nín", "pos": "pronoun", "meaning": "vous (de politesse)" },
            "他": { "name": "他", "pinyin": "tā", "pos": "pronoun", "meaning": "il" },
            "她": { "name": "她", "pinyin": "tā", "pos": "pronoun", "meaning": "elle" },
            "我们": { "name": "我们", "pinyin": "wǒmen", "pos": "pronoun", "meaning": "nous" },
            "你们": { "name": "你们", "pinyin": "nǐmen", "pos": "pronoun", "meaning": "vous" },
            "他们": { "name": "他们", "pinyin": "tāmen", "pos": "pronoun", "meaning": "ils" },
            "法国": { "name": "法国", "pinyin": "fǎguó", "pos": "proper noun", "meaning": "France", "category": "country" },
            "英国": { "name": "英国", "pinyin": "yīngguó", "pos": "proper noun", "meaning": "Angleterre", "category": "country" },
            "美国": { "name": "美国", "pinyin": "měiguó", "pos": "proper noun", "meaning": "U.S.A", "category": "country" },
            "意大利": { "name": "意大利", "pinyin": "yìdàlì", "pos": "proper noun", "meaning": "Italie", "category": "country" },
            "中国": { "name": "中国", "pinyin": "zhōngguó", "pos": "proper noun", "meaning": "Chine", "category": "country" },
            "人": { "name": "人", "pinyin": "rén", "pos": "noun", "meaning": "gens (personne)" },
            "笔": { "name": "笔", "pinyin": "bǐ", "pos": "noun", "meaning": "crayon", "category": "thing" },
            "白": { "name": "白", "pinyin": "bái", "pos": "noun", "meaning": "blanc", "category": "color" },
            "几": { "name": "几", "pinyin": "jǐ", "pos": "xxx", "meaning": "quelque/combien"},
            "是": { "name": "是", "pinyin": "shì", "pos": "verb", "meaning": "être"},
            "学": { "name": "学", "pinyin": "xué", "pos": "verb", "meaning": "apprendre"},
            "中文": { "name": "中文", "pinyin": "zhōngwén", "pos": "noun", "meaning": "chinois(la langue)"},
            "汉语" : { "name": "汉语", "pinyin": "hànyǔ", "pos": "noun", "meaning": "mandarin(la langue)"},
            "韩语" : { "name": "韩语", "pinyin": "hányǔ", "pos": "noun", "meaning": "corean(la langue)"},
            "也" : { "name": "也", "pinyin": "yě", "pos": "adverb", "meaning": "aussi"},
            "吗" : { "name": "吗", "pinyin": "ma", "pos": "particule", "meaning": "particule interogative"},
            "姓" : { "name": "姓", "pinyin": "xìng", "pos": "verb", "meaning": "appeler (nom de famille)"},
            "什么" : { "name": "什么", "pinyin": "shénme", "pos": "adjectiv", "meaning": "quoi"},
            "李" : { "name": "李", "pinyin": "lǐ", "pos": "-", "meaning": "racine de prune (lizi) et nom de famille (Lee)"},
            "王" : { "name": "王", "pinyin": "Wáng", "pos": "noun", "meaning": "roi et nom de famille (wang)"},
            "张" : { "name": "张", "pinyin": "Zhāng", "pos": "-", "meaning": "nom de famille (Zhāng)"},
            "弓" : { "name": "弓", "pinyin": "gōng", "pos": "noun", "meaning": "arc, et nom de famille (Gōng)"},
            "叫" : { "name": "叫", "pinyin": "jiào", "pos": "verb", "meaning": "appeler (nom complet)"},
            "名字" : { "name": "名字", "pinyin": "míngzì", "pos": "noun", "meaning": "prenom"},
            "成龙" : { "name": "成龙", "pinyin": "chénglóng", "pos": "proper noun", "meaning": "Jackie Chan"},
            "龙" : { "name": "龙", "pinyin": "lóng", "pos": "noun", "meaning": "dragon"},
            "哪" : { "name": "哪", "pinyin": "nǎ", "pos": "adjectif", "meaning": "quel/lequel"},
            "国人" : { "name": "国人", "pinyin": "guórén", "pos": "noun", "meaning": "pays"},
            "大"  : { "name": "大", "pinyin": "dà", "pos": "adjectiv", "meaning": "grand"},
            "羊"  : { "name": "羊", "pinyin": "yáng", "pos": "noun", "meaning": "mouton"},
            "山羊"  : { "name": "山羊", "pinyin": "shānyáng", "pos": "noun", "meaning": "chevre (mouton des montagnes)"},
            "美"  : { "name": "美", "pinyin": "měi", "pos": "adjectiv", "meaning": "beau/jolie"},
            "很"  : { "name": "很", "pinyin": "hěn", "pos": "adjverb", "meaning": "tres"},
            "小"  : { "name": "小", "pinyin": "xiǎo", "pos": "adjectiv", "meaning": "petit/jeune"},
            "矮"  : { "name": "矮", "pinyin": "ǎi", "pos": "adjectiv", "meaning": "petit(taille, utiliser sur les humain?)"},
            "高"  : { "name": "高", "pinyin": "gāo", "pos": "adjectiv", "meaning": "grand(taille)"},
            "老"  : { "name": "老", "pinyin": "lǎo", "pos": "adjectiv", "meaning": "vieux"},
            "老师"  : { "name": "老师", "pinyin": "lǎoshī", "pos": "noun", "meaning": "professeur"},
            "天安门"  : { "name": "天安门", "pinyin": "tiān'ānmén", "pos": "proper noun", "meaning": "Place Tiananmen"},
            "先生"  : { "name": "先生", "pinyin": "xiānshēng", "pos": "noun", "meaning": "monsieur"},
            "天"  : { "name": "天", "pinyin": "tiān", "pos": "noun", "meaning": "journée/ciel"},
            "好"  : { "name": "好", "pinyin": "hǎo", "pos": "adjectiv", "meaning": "bien"},
            "岁"  : { "name": "岁", "pinyin": "suì", "pos": "noun", "meaning": "age"},
            "去"  : { "name": "去", "pinyin": "qù", "pos": "verb", "meaning": "aller"},
            "来"  : { "name": "来", "pinyin": "lái", "pos": "verb", "meaning": "venir"},
            "第"  : { "name": "第", "pinyin": "dì", "pos": "-", "meaning": "prefix de position (premier diyi, deuxieme dier, etc..."},
            "小羊"  : { "name": "小羊", "pinyin": "xiǎoyáng", "pos": "noun", "meaning": "agneau (petit mouton)"},
            "小牛"  : { "name": "小牛", "pinyin": "xiǎo niú", "pos": "noun", "meaning": "veau (petite vache)"},
            "牛"  : { "name": "牛", "pinyin": "niú", "pos": "noun", "meaning": "vache"},
            "笑"  : { "name": "笑", "pinyin": "xiào", "pos": "noun", "meaning": "rire (nom et verbe"},
            "声"  : { "name": "声", "pinyin": "shēng", "pos": "noun", "meaning": "ton (son)"},
            "了"  : { "name": "了", "pinyin": "le", "pos": "particule", "meaning": "Particule, action passé"},
            "子"  : { "name": "子", "pinyin": "zi", "pos": "noun", "meaning": "enfant (fils)"},
            "汉字"  : { "name": "汉字", "pinyin": "hànzì", "pos": "noun", "meaning": "caractère chinois (glyphe)"},
            "书"  : { "name": "书", "pinyin": "shū", "pos": "noun", "meaning": "livre"},
            "法语" : { "name": "法语", "pinyin": "fǎyǔ", "pos": "adjectiv", "meaning": "français"},
            "有" : { "name": "有", "pinyin": "yǒu", "pos": "verb", "meaning": "avoir"},
            "本" : { "name": "本", "pinyin": "běn", "pos": "quantifier", "meaning": "quantifieur pour les livres"},
            "云" : { "name": "云", "pinyin": "yún", "pos": "noun", "meaning": "nuage"},
            "风" : { "name": "风", "pinyin": "fēng", "pos": "noun", "meaning": "vent"},
            "北京" : { "name": "北京", "pinyin": "běijīng", "pos": "proper noun", "meaning": "Pekin"},
            "北":  { "name": "北", "pinyin": "běi", "pos": "noun", "meaning": "nord"},
            "南":  { "name": "南", "pinyin": "nán", "pos": "noun", "meaning": "sud"},
            "京":  { "name": "京", "pinyin": "jīng", "pos": "noun", "meaning": "capital (d'un pays)"},
            "女儿": { "name": "女儿", "pinyin": "nǚ'ér", "pos": "noun", "meaning": "fille (feminin de fils)"},
            "儿子": { "name": "儿子", "pinyin": "érzi", "pos": "noun", "meaning": "fils (masculin de fille)"},
            "公司": { "name": "公司", "pinyin": "gōngsī", "pos": "noun", "meaning": "société/entreprise"},
            "咖啡": { "name": "咖啡", "pinyin": "kāfēi", "pos": "noun", "meaning": "café"},
            "身体": { "name": "身体", "pinyin": "shēntǐ", "pos": "noun", "meaning": "le corps/la santé"},
            "妈妈": { "name": "妈妈", "pinyin": "māmā", "pos": "noun", "meaning": "maman/mère"},
            "谢谢": { "name": "谢谢", "pinyin": "xièxiè", "pos": "noun", "meaning": "merci"},
            "不": { "name": "不", "pinyin": "bù", "pos": "adverb", "meaning": "negation (ne pas)"},
            "不客气": { "name": "不客气", "pinyin": "bù kèqì", "pos": "adverb", "meaning": "de rien/je vous en prie (fixer le ton XXX)"},
            "客人": { "name": "客人", "pinyin": "kèrén", "pos": "noun", "meaning": "invités/clients"},
            "休息": { "name": "休息", "pinyin": "xiūxí", "pos": "verb", "meaning": "se reposer"},
            "牛奶": { "name": "牛奶", "pinyin": "niúnǎi", "pos": "noun", "meaning": "lait (de vache)"},
            "啤酒": { "name": "啤酒", "pinyin": "píjiǔ", "pos": "noun", "meaning": "bière"},
            "米酒": { "name": "米酒", "pinyin": "mǐjiǔ", "pos": "noun", "meaning": "saké (alcool de riz)"},
            "大米": { "name": "大米", "pinyin": "dàmǐ", "pos": "noun", "meaning": "riz (la plante?XXX)"},
            "米饭": { "name": "米饭", "pinyin": "mǐfàn", "pos": "noun", "meaning": "riz (le plat)"},
            "梅酒": { "name": "梅酒", "pinyin": "méijiǔ", "pos": "noun", "meaning": "vin de prune"},
            "酒": { "name": "酒", "pinyin": "jiǔ", "pos": "noun", "meaning": "boisson alcolisée"},
            "鸡蛋": { "name": "鸡蛋", "pinyin": "jīdàn", "pos": "noun", "meaning": "oeuf"},
            "红酒": { "name": "红酒", "pinyin": "hóngjiǔ", "pos": "noun", "meaning": "vin rouge"},
            "足球": { "name": "足球", "pinyin": "zúqiú", "pos": "noun", "meaning": "football"},
            "网球": { "name": "网球", "pinyin": "wǎngqiú", "pos": "noun", "meaning": "tennis"},
            "榴莲": { "name": "榴莲", "pinyin": "Liúlián", "pos": "noun", "meaning": "Durian"},
            "打开": { "name": "打开", "pinyin": "dǎkāi", "pos": "verb", "meaning": "allumer/ouvrir(un livre)"},
            "大声": { "name": "大声", "pinyin": "dàshēng", "pos": "adjectiv", "meaning": "Bruyamment"},
            "读": { "name": "读", "pinyin": "dú", "pos": "verb", "meaning": "lire/prononcer"},
            "请": { "name": "请", "pinyin": "qǐng", "pos": "-", "meaning": "SVP"},
            "问": { "name": "问", "pinyin": "wèn", "pos": "verb", "meaning": "demander"},
            "请问": { "name": "请问", "pinyin": "qǐngwèn", "pos": "-", "meaning": "excusez moi"},
            "再见": { "name": "再见", "pinyin": "zàijiàn", "pos": "-", "meaning": "au revoir"},
            "一起": { "name": "一起", "pinyin": "yīqǐ", "pos": "-", "meaning": "ensemble"},
            "对不起": { "name": "对不起", "pinyin": "duìbùqǐ", "pos": "-", "meaning": "désolé"},
            "问题": { "name": "问题", "pinyin": "wèntí", "pos": "noun", "meaning": "problème/question"},
            "个": { "name": "个", "pinyin": "gè", "pos": "quantifier", "meaning": "quantifieur generique"},
            "没": { "name": "没", "pinyin": "méi", "pos": "-", "meaning": "negation (pour avoir)"},
            "学生": { "name": "学生", "pinyin": "xuéshēng", "pos": "noun", "meaning": "etudiant (eleve)"},
            "大学生": { "name": "大学生", "pinyin": "dàxuéshēng", "pos": "noun", "meaning": "etudiant (haute-etude)"},
            "小学生": { "name": "小学生", "pinyin": "xiǎoxuéshēng", "pos": "noun", "meaning": "élève de primaire"},
            "中学生": { "name": "中学生", "pinyin": "zhōngxuéshēng", "pos": "noun", "meaning": "collégien"},
            "哪儿": { "name": "哪儿", "pinyin": "nǎ'er", "pos": "particule", "meaning": "où"},
            "这": { "name": "这", "pinyin": "zhè", "pos": "-", "meaning": "Ceci (this)"},
            "那": { "name": "那", "pinyin": "nà", "pos": "-", "meaning": "Cela (that)"},
            "巴黎": { "name": "巴黎", "pinyin": "bālí", "pos": "proper noun", "meaning": "Paris"},
        },
    "sentence":
        [
            {
                "chinese": "我|五|岁",
                "french": "J'ai 5 ans"
            },
            {
                "chinese": "你|几|岁",
                "french": "Tu as quel age?"
            },
            {
                "chinese" : "我们|学|中文",
                "french": "Nous apprenons le chinois",
                "seance" : 1
            },
            {
                "chinese" : "我们|学|汉语",
                "french": "Nous apprenons le Mandarin",
                "seance" : 1
            },
            {
                "chinese" : "我们|学|韩语",
                "french": "Nous apprenons le Coreen",
                "seance" : 1
            },
            {
                "chinese" : "你们|是|法国|人",
                "french": "Vous êtes français",
                "seance" : 1
            },
            {
                "chinese" : "他们|也|学|中文|吗",
                "french": "Apprennent-ils aussi le chinois",
                "seance" : 1
            },
            {
                "chinese" : "你|姓|什么",
                "french": "Quel est votre nom de famille?",
                "seance" : 1
            },
            {
                "chinese" : "我|姓|李",
                "french": "Mon nom de famille est Li",
                "seance" : 1
            },
            {
                "chinese" : "你|叫|什么",
                "french": "Quel est votre nom?",
                "seance" : 1
            },
            {
                "chinese" : "你|叫|什么|名字",
                "french": "Comment tu t'appele (nom complet)",
                "seance" : 1
            },
            {
                "chinese" : "你|是|哪|国人",
                "french": "De quel pays êtes vous?",
                "seance" : 1
            },
            {
                "chinese" : "我|是|中国|人",
                "french": "je suis Chinois",
                "seance" : 1
            },
            {
                "chinese" : "法国|很|美",
                "french": "La France est belle (verbe pas obligatoire)",
                "seance" : 1
            },
            {
                "chinese" : "我|很|好",
                "french": "Je vais bien",
                "seance" : 1
            },
            {
                "chinese" : "她|很|小",
                "french": "Elle est très petite",
                "seance" : 1
            },
            {
                "chinese" : "中国|很|大|，|法国|很|小",
                "french": "La Chine est très grande, la France est très petite",
                "seance" : 1
            },
            {
                "chinese" : "他|很|矮",
                "french": "Il est petit",
                "seance" : 1
            },
            {
                "chinese" : "她|去|中国",
                "french": "Elle va en Chine",
                "seance" : 2
            },
            {
                "chinese" : "你|来|吗",
                "french": "Tu viens?",
                "seance" : 2
            },
            {
                "chinese" : "第|几|声",
                "french": "C'est quel ton",
                "seance" : 2
            },
            {
                "chinese" : "第|二|声",
                "french": "C'est le 2eme ton",
                "seance" : 2
            },
            {
                "chinese" : "她|笑|了",
                "french": "Elle a rie",
                "seance" : 2
            },
            {
                "chinese" : "我|有|一|本|汉语|书",
                "french": "J'ai un livre chinois",
                "seance" : 2
            },
            {
                "chinese" : "你|身体|好|吗",
                "french": "Tu va bien?",
                "seance" : 2
            },
            {
                "chinese" : "你|妈妈|身体|好|吗",
                "french": "Ta maman va bien?",
                "seance" : 2
            },
            {
                "chinese" : "你|好|吗",
                "french": "Tu va bien?",
                "seance" : 2
            },
            {
                "chinese" : "她|不|去|中国",
                "french": "Elle n'ira pas en Chine",
                "seance" : 2
            },
            {
                "chinese" : "请问|您|是|法国|人|吗",
                "french": "Puis-je vous demander si vous etes francais?",
                "seance" : 2
            },
            {
                "chinese" : "请问|你|叫|什么|名字",
                "french": "Puis-je vous demander quel est votre nom?",
                "seance" : 2
            },
            {
                "chinese" : "一起|读",
                "french": "Lisez ensemble",
                "seance" : 2
            },
            {
                "chinese" : "你们|一起|学|汉语",
                "french": "Vous apprenez le chinois ensemble",
                "seance" : 2
            },
            {
                "chinese" : "我|有|一|个|问题",
                "french": "J'ai une question",
                "seance" : 2
            },
            {
                "chinese" : "她|有|一|个|儿子",
                "french": "Elle a un fils",
                "seance" : 2
            },
            {
                "chinese" : "你|有|汉语|书|吗",
                "french": "Avez vous un livre de chinois",
                "seance" : 2
            },
            {
                "chinese" : "您|是|老师|吗",
                "french": "Etes vous professeur?",
                "seance" : 2
            },
            {
                "chinese" : "是|，|我|是|老师",
                "french": "Oui, je suis professeur",
                "seance" : 2
            },
            {
                "chinese" : "不|，|我|不|是|老师|，|我|是|学生",
                "french": "Non, je ne suis pas professeur. Je suis étudiant.",
                "seance" : 2
            },
            {
                "chinese" : "你|是|法国|人|吗",
                "french": "Tu es français?",
                "seance" : 2
            },
            {
                "chinese" : "我|是|美国|人",
                "french": "Je suis Américain",
                "seance" : 2
            },
            {
                "chinese" : "这|是|哪儿",
                "french": "Où est-ce?",
                "seance" : 2
            },
            {
                "chinese" : "这|是|法国|巴黎",
                "french": "C'est Paris en France",
                "seance" : 2
            },
            
            
            
        ]
}